import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 257 232" {...props}><path fill="currentColor" d="M.2 115.5L.5 231l43.8.3 43.7.2v-57.8c0-49.4.2-57.8 1.4-57.5.8.2 18.6 25.9 39.6 57.3l38.1 57 44.5.5c24.5.3 44.8.3 45 .1.2-.2.4-52.3.4-115.8V0h-89v58c0 36.6-.4 58-1 58-.5 0-1.5-1-2.1-2.3-1.3-2.4-13.9-21.3-51.8-77.7L89.3.5 44.6.2 0 0l.2 115.5z" /></svg>);